// frontend/src/components/admin/RequireAdmin.js
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Sama env-mekaniikka kuin muualla frontissa
const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const apiUrl = (path) => (API_BASE ? `${API_BASE}${path}` : path);
const PROFILE_ENDPOINT = apiUrl('/api/profile');

export default function RequireAdmin({ children }) {
  const { isReady, isAuthenticated, getAuthHeaders } = useAuth();
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let alive = true;

    const run = async () => {
      if (!isReady) return; // odota että AuthContext hydraa sessionin
      if (!isAuthenticated) {
        const next = encodeURIComponent(location.pathname + location.search);
        navigate(`/login?next=${next}`, { replace: true });
        return;
      }
      try {
        const res = await fetch(PROFILE_ENDPOINT, { headers: { ...getAuthHeaders() } });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const me = await res.json();
        if (me?.role === 'admin') {
          if (alive) { setAllowed(true); setChecking(false); }
        } else {
          navigate('/403', { replace: true });
        }
      } catch {
        navigate('/login', { replace: true });
      } finally {
        if (alive) setChecking(false);
      }
    };

    run();
    return () => { alive = false; };
  }, [isReady, isAuthenticated, getAuthHeaders, navigate, location.pathname, location.search]);

  if (checking) {
    return (
      <div style={{ padding: 24 }}>
        <p>Tarkistetaan käyttöoikeuksia…</p>
      </div>
    );
  }
  return allowed ? children : null;
}
